import { IDisposable } from "Global/Base/IDisposable";
import { ICompositeComponent, IGenericControl, IHasEncryptionState } from "../../Controls/ControlInterfaces";
import { ILoader } from "../../ILoader";
import { IFormControl, IValidationMaster } from "../FormControl";
import { IFrameWithKeyboardNavigation, IFrameWithProfile, IMultiRecordsComponent } from "./FrameInterfaces";
import { IDetailMasterableFrame } from "./IDetailMasterableFrame";

export interface ITreeViewFrame extends IDisposable, IValidationMaster, IDetailMasterableFrame, IMultiRecordsComponent, IFrameWithProfile, IFrameWithKeyboardNavigation, IFormControl, IHasEncryptionState, ILoader, IGenericControl, ICompositeComponent {
    readonly isTreeViewFrame: boolean;
}

export class ITreeViewFrame {
    private static _properties: (keyof ITreeViewFrame)[] = ["isTreeViewFrame"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            !this._properties.some((value) => !Reflect.has(instance, value));
    }
}
